class Filter {
  private filter: HTMLElement;
  private root: HTMLElement = document.querySelector('html, body') as HTMLElement;
  private url: string = window.location.href;
  private filterContent: HTMLElement;
  private filterContentId: string;
  private target: HTMLElement;
  private newsListing: NodeListOf<HTMLElement> = document.querySelectorAll('.news--listing') as NodeListOf<HTMLElement>;
  private tagDropdown: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.tag__dropdown') as NodeListOf<HTMLSelectElement>;

  constructor(filter: HTMLElement) {
    this.filter = filter;
    this.filterContent = this.filter.querySelector('.filter-content') as HTMLElement;
    this.filterContentId = this.filterContent.getAttribute('data-placeholder-label')?.toLowerCase().replace(/ /g, '-') ?? '';
    this.target = this.filterContent.querySelector(`[id="${this.filterContentId}"]`) as HTMLElement;

    this.init();
  }

  init(): void {
    this.isFilterOrSearch();
  }

  private isFilterOrSearch(): void {
    if (this.url.match(/-in-tags/g) != null) {
      this.tagDropdown.forEach((dropdown) => {
        const selectedOption = dropdown.querySelector(`option[value="${this.url}"]`);
        if (selectedOption) {
          dropdown.value = this.url;
        }
      });
    } else if (this.url.match(/searchQuery/g) != null) {
      this.newsListing.forEach((listing) => {
        listing.classList.add('hidden');
      });
    }
    if (this.target) {
      this.root.scrollTo(0, this.target.offsetTop);
    }
  }
}

document.querySelectorAll('.filter').forEach((filter) => {
  new Filter(filter as HTMLElement);
});
